var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.667V12.667C16.5 14.0671 16.5 14.7672 16.2275 15.302C15.9878 15.7724 15.6054 16.1548 15.135 16.3945C14.6002 16.667 13.9001 16.667 12.5 16.667H5.5C4.09987 16.667 3.3998 16.667 2.86502 16.3945C2.39462 16.1548 2.01217 15.7724 1.77248 15.302C1.5 14.7672 1.5 14.0671 1.5 12.667V11.667M13.1667 7.50032L9 11.667M9 11.667L4.83333 7.50032M9 11.667V1.66699",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.7a4b1078d3b0f587c0ca27b7ef4ee6c5.svg";
export { ForwardRef as ReactComponent };